
<template>

  <div class="index">
    
          <div
            v-for="(value,itemkey,index) in allBuyArray"
            :key="index"
            class="listView"
          >
            <van-row type="flex" justify="center" align="center" class="classText">
              {{itemkey + "                    (小计: "+numList[itemkey]+"人)"}}
            </van-row>
            <van-row type="flex" justify="center" align="center" class="lineView"/>

              <div
                v-for="(itemSub, index) in value"
                :key="index"
              >
                <van-row type="flex" justify="center" align="center">
                  <van-col span="8" type="flex" justify="center" align="center" class="nameText">{{itemSub[0]}}</van-col>
                  <van-col span="8" type="flex" justify="center" align="center" class="nameText">{{itemSub[1]}}</van-col>
                  <van-col span="8" type="flex" justify="center" align="center" class="nameText">{{itemSub[2]}}</van-col>
                </van-row>
              </div>
          </div>

          <van-row type="flex" justify="center" align="center" class="titleText">
            {{ "获得总积分: "+ score.toFixed(2)+"      商品购买总人数: "+count}}
          </van-row>
  </div>
</template>
<script>

import {  Row, Col  } from 'vant';

export default {
  name: "GoodList",
  components: {
    [Row.name]:Row,
    [Col.name]:Col
  },
  props: {
    goodList: {
      type: Array,
      default: () => []
    },
    numList: {
      type: Array,
      default: () => {}
    },
    allBuyArray: {
      type: Object,
      default: () => {}
    },
    score: {
      type: String,
      default: "0"
    },
    count: {
      type: String,
      default: "0"
    },
    isSort: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {};
  },
  mounted: function() {
    console.log("-----------");
    // console.log(this.allBuyArray);
    console.log(this.score);
  }
};
</script>
<style scoped>
.pictrueList {
  padding: 2%;
}

.index {
  background-color: #fff;
  margin:0;
  padding:0;
  height:100%;
}
.listView {
  background-color: #fff;
  height: 90%;
}
.lineView {
  background-color: rgb(26, 3, 3);
  height: 1px;

}

.titleText {
  position:fixed;
  font-size: 16px;
  background-color: rgb(209, 88, 88);
  color: black;
  width: 100%;
  height: 10%;
  top: 90%;
}

.classText {
  font-size: 14px;
  background-color: rgb(232, 236, 241);
  color: black;
  height: 26px;
}
.nameText {
  font-size: 14px;
  background-color:white;
  color: black;
  height: 24px;
  text-align:center;
}

</style>
